export class StringValueCountKeyValuePair{
	string_value: string;
	items_count: number;
}

export const StringValueCountKeyValuePair_EmptyEntity = [{
	string_value: "",
	items_count: 0,
}] as StringValueCountKeyValuePair[];